module.exports = __webpack_public_path__ + "img/wood2.7752fc7c.jpg";